// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iAaq","toggle":"styles_toggle__1e15u","preview":"styles_preview__1Ay2a"};